import Dropdown from '../Dropdown';
import { UNDELIVERED_REASON_META, UNDELIVERED_REASONS } from '../undeliveredFamilies';

// Options derive from the shared reason metadata so labels never drift from the
// badges rendered in the table (DR-2855). '' means "no filter".
const OPTIONS = [
  { label: 'All reasons', value: '' },
  ...UNDELIVERED_REASONS.map((reason) => ({
    label: UNDELIVERED_REASON_META[reason].label,
    value: reason,
  })),
];

export default function UndeliveredReasonFilter({
  reason,
  onReasonChange,
}: {
  reason: string;
  onReasonChange: (value: string) => void;
}) {
  return (
    <div className="flex flex-col gap-2 justify-between">
      <label
        htmlFor="undelivered-reason"
        className="block text-sm font-medium text-gray-700 dark:text-zinc-100 mb-1"
      >
        Reason
      </label>
      <Dropdown id="undelivered-reason" value={reason} onChange={onReasonChange} options={OPTIONS} />
    </div>
  );
}
